import { TWidget } from 'widgets/Widget';

type TPayloadQuickView = {
    pid: string;
};

/**
 * @param Widget Base widget for extending
 * @returns OptimizelyEvents class
 */
function OptimizelyEventsClassCreator(Widget: TWidget) {
    class OptimizelyEvents extends Widget {
        prefs() {
            return {
                quickViewPath: '',
                ...super.prefs()
            };
        }

        init() {
            super.init();

            window.addEventListener('OptimizelyQuickShop', event => {
                const payload = (event as CustomEvent<TPayloadQuickView>).detail;
                const quickViewPath = this.prefs().quickViewPath;

                if (payload && payload.pid) {
                    this.eventBus().emit('drawershow', {
                        url: `${quickViewPath}${payload.pid}`,
                        wrapperClasses: 'm-quick_buy'
                    });
                }
            });
        }
    }

    return OptimizelyEvents;
}

export type TOptimizelyEvents = ReturnType<typeof OptimizelyEventsClassCreator>;

export type TOptimizelyEventsInstance = InstanceType<TOptimizelyEvents>;

export default OptimizelyEventsClassCreator;
